import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';
import { getNotificationForStatus, shouldSignOutForStatus } from './httpErrorHandling';

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000
})

// Config
const TOKEN_PAYLOAD_KEY = 'authorization'

// API Request interceptor
service.interceptors.request.use(config => {
	const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

	if (jwtToken) {
		config.headers[TOKEN_PAYLOAD_KEY] = jwtToken
	}

	return config
}, error => {
	// Do something with request error here
	notification.error({
		message: 'Error'
	})
	Promise.reject(error)
})

// API respone interceptor
service.interceptors.response.use( (response) => {
	return response.data
}, (error) => {
	const status = error?.response?.status;
	let notificationParam = getNotificationForStatus(status, error?.response?.data);

	// Remove token and redirect only when the session is actually invalid/expired.
	// Validation errors (400) must stay on the current form so users can correct input.
	if (shouldSignOutForStatus(status)) {
		localStorage.removeItem(AUTH_TOKEN)

		store.dispatch(signOutSuccess())
	}

	if (!error?.config?.suppressErrorNotification) {
		notification.error(notificationParam)
	}

	return Promise.reject(error);
});

export default service
